import { DELIVERY_LIST_TYPE, FRONT_PATHS, MOBILE_TYPE, REAR_PATHS, VIEW_TYPES } from './constants';

const onCancelPathsMap = {
  [VIEW_TYPES.REAR_LOADING]: {
    byType: {
      [MOBILE_TYPE]: REAR_PATHS.CREATE_ORDER_BY_PHONE,
      [DELIVERY_LIST_TYPE]: REAR_PATHS.DELIVERY_LIST,
    },
    default: REAR_PATHS.CREATE_ORDER,
  },
  [VIEW_TYPES.FRONT_LOADING]: {
    byType: {
      [DELIVERY_LIST_TYPE]: FRONT_PATHS.DELIVERY_LIST,
    },
    default: FRONT_PATHS.CREATE_ORDER,
  },
} as const;

export function getOnCancelRedirectPath(frodoContext: VIEW_TYPES, type: string): string {
  const { byType, default: defaultPath } = onCancelPathsMap[frodoContext];
  return byType[type] || defaultPath;
}
